import type { BriefDeliverable, BriefDeliverablePlatform } from '@fluenceur/types';

export interface DeliverablePreset {
  /** Stable key for the add-menu and i18n label lookup. */
  key: string;
  platform: BriefDeliverablePlatform;
  /** Persisted free-form format value. */
  format: string;
}

/** The four deliverable formats offered by the add menu (design order). */
export const DELIVERABLE_PRESETS: DeliverablePreset[] = [
  { key: 'postFeed', platform: 'instagram', format: 'post' },
  { key: 'storySequence', platform: 'instagram', format: 'story' },
  { key: 'reel', platform: 'instagram', format: 'reel' },
  { key: 'video', platform: 'tiktok', format: 'video' },
];

const PRESET_BY_FORMAT = new Map(DELIVERABLE_PRESETS.map((p) => [`${p.platform}:${p.format}`, p]));

/** Resolve the preset for a deliverable so its label/platform render consistently. */
export const presetForDeliverable = (
  deliverable: Pick<BriefDeliverable, 'platform' | 'format'>
): DeliverablePreset | undefined =>
  PRESET_BY_FORMAT.get(`${deliverable.platform}:${deliverable.format}`);

/** Build a fresh deliverable from a preset (client uuid, quantity 1). */
export const deliverableFromPreset = (preset: DeliverablePreset): BriefDeliverable => ({
  id: crypto.randomUUID(),
  platform: preset.platform,
  format: preset.format,
  quantity: 1,
});
